import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterType } from 'app/bookings/GlobalBookingSearchModal/GlobalBookingSearchModal';
import { SEARCH_DATE_OPTIONS } from 'app/app.types';
export interface IGlobalSearchModalState {
    isOpen: boolean;
    searchResults: any[];
    filterDate?: string;
    loading: boolean;
    moreLoading: boolean;
    loadError: boolean;
    bookmark?: string;
    searchQuery: string;
    searchLevel: SEARCH_DATE_OPTIONS;
}

const initialState: IGlobalSearchModalState = {
    isOpen: false,
    searchResults: [],
    filterDate: undefined,
    loading: false,
    moreLoading: false,
    loadError: false,
    bookmark: undefined,
    searchQuery: '',
    searchLevel: SEARCH_DATE_OPTIONS.FUTURE,
};

const globalSearchModalSlice = createSlice({
    name: 'globalSearchModal',
    initialState,
    reducers: {
        openGlobalSearchModal: (state, action: PayloadAction<{ filterDate?: string }>) => {
            state.isOpen = true;
            state.filterDate = action.payload.filterDate;
        },
        closeGlobalSearchModal: (state) => {
            state.isOpen = false;
            state.searchResults = [];
            state.filterDate = undefined;
            state.loading = false;
            state.moreLoading = false;
            state.loadError = false;
            state.bookmark = undefined;
            state.searchQuery = '';
        },
        setSearchResults: (state, action: PayloadAction<any[]>) => {
            state.searchResults = action.payload;
        },
        appendSearchResults: (state, action: PayloadAction<any[]>) => {
            state.searchResults = [...state.searchResults, ...action.payload];
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMoreLoading: (state, action: PayloadAction<boolean>) => {
            state.moreLoading = action.payload;
        },
        setLoadError: (state, action: PayloadAction<boolean>) => {
            state.loadError = action.payload;
        },
        setBookmark: (state, action: PayloadAction<string | undefined>) => {
            state.bookmark = action.payload;
        },
        setSearchQuery: (state, action: PayloadAction<string>) => {
            state.searchQuery = action.payload;
        },
        setSearchLevel: (state, action: PayloadAction<SEARCH_DATE_OPTIONS>) => {
            state.searchLevel = action.payload;
        },
    },
});

export const {
    openGlobalSearchModal,
    closeGlobalSearchModal,
    setSearchResults,
    appendSearchResults,
    setLoading,
    setMoreLoading,
    setLoadError,
    setBookmark,
    setSearchQuery,
    setSearchLevel
} = globalSearchModalSlice.actions;
export default globalSearchModalSlice.reducer;
